export default __webpack_public_path__ + "static/media/CarRecoveryBanner.66fe782a.png";